import endsWith from 'lodash/endsWith';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { textColor, THEME_MUTED } from '../../../styles/basics/colors';
import { useTranslation } from 'react-i18next';

const StFormatText = styled.p`
    font-size: 15px;
    margin-bottom: 0;
    word-wrap: break-word;
`;

StFormatText.displayName = 'LCProductDetailAssetEbook__StFormatText';

const StPlaceholderText = styled.p`
    font-size: 15px;
    ${textColor(THEME_MUTED)};
`;

const StIcon = styled.i`
    font-size: 34px;
`;

interface Props {
    fileName?: string;
}

export const LCProductDetailAssetEbook = ({ fileName }: Props) => {
    const { t } = useTranslation();
    if (!fileName) {
        return <StPlaceholderText>{t('yourLocalContent.yourTitles.warnings.noEbookAdded')}</StPlaceholderText>;
    }

    const lowerFileName = fileName?.toLowerCase();

    let icon: ReactNode;

    if (endsWith(lowerFileName, 'epub')) {
        icon = <StIcon className="bolinda-icons">file_epub</StIcon>;
    } else if (endsWith(lowerFileName, 'pdf')) {
        icon = <StIcon className="bolinda-icons">file_pdf</StIcon>;
    }

    return (
        <StFormatText>
            {icon} {fileName}
        </StFormatText>
    );
};
